import script from "./DegradationBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./DegradationBanner.vue?vue&type=script&setup=true&lang=js"

import "./DegradationBanner.vue?vue&type=style&index=0&id=22f99542&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f99542"]])

export default __exports__